export function fullScreen() {
  console.log('fullScreen')
  var element = document.body
  var requestMethod =
    element.requestFullScreen || //W3C
    element.webkitRequestFullScreen || //FireFox
    element.mozRequestFullScreen || //Chrome等
    element.msRequestFullscreen; //IE11
  if (requestMethod) {
    requestMethod.call(element);
  }
}
export function exitFullScreen() {
  var requestMethod =
    document.exitFullScreen || //W3C
    document.webkitExitFullscreen || //FireFox
    document.mozCancelFullScreen || //Chrome等
    document.msExitFullscreen; //IE11
  if (requestMethod) {
    requestMethod.call(document);
  }
}
export function formatResultFunc(key, value) {
  if (key === 'VISION_CHALLENGE') {
    return {
      leftEyeVision: value.leftData,
      rightEyeVision: value.rightData,
      type: "VISION_CHALLENGE"
    };
  } else if (key === 'CONTRAST_SENSITIVITY_TRAINING') {
    console.log('>>>SS', value.data)
    const valueCeil = value.data.map(item => {
      console.log('>>>item', item)
      item.data.forEach(o => {
        o[1] = parseFloat(o[1].toFixed(1))
        console.log('>>>o', o)
      })
      return item
    })
    value.data = valueCeil
    return {
      result: value,
      type: key
    }
  } else {
    return {
      result: value,
      type: key
    };
  }
}



// WEBPACK FOOTER //
// ./src/common/util.js